import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AdminProvider, useAdmin } from "./lib/admin";
import ScrollToTop from "./components/ScrollToTop";
import Layout from "./components/Layout";
import Landing from "./pages/Landing";
import Pricing from "./pages/Pricing";
import Checkout from "./pages/Checkout";
import PaymentResult from "./pages/PaymentResult";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Faq from "./pages/Faq";
import Legal from "./pages/Legal";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import "./App.css";

function AdminRoute({ children }) {
  const { admin, ready } = useAdmin();
  if (!ready) return <div className="min-h-screen grid place-items-center text-zinc-500">Loading…</div>;
  if (!admin) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <AdminProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Marketing + portal (with nav/footer) */}
          <Route element={<Layout />}>
            <Route path="/" element={<Landing />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/about" element={<About />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/legal/:slug" element={<Legal />} />
          </Route>

          {/* Checkout + payment states (no marketing chrome) */}
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/payment/success" element={<PaymentResult status="success" />} />
          <Route path="/payment/failure" element={<PaymentResult status="failure" />} />
          <Route path="/payment/cancel" element={<PaymentResult status="cancel" />} />

          {/* Admin */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" theme="dark" richColors />
    </AdminProvider>
  );
}

export default App;
